import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { useAuthStore } from "@/store/auth";
export function Login() {
    const navigate = useNavigate();
    const setAuth = useAuthStore((state) => state.setAuth);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    async function handleSubmit(e) {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const tokens = await api.post("/auth/login", {
                email,
                password,
            });
            // Save token BEFORE calling /auth/me so the API client sends the
            // Authorization header (F1 fix).
            localStorage.setItem("biotact_access_token", tokens.access_token);
            const me = await api.get("/auth/me");
            setAuth(tokens.access_token, me);
            navigate("/");
        }
        catch (err) {
            const message = err instanceof Error ? err.message : "Login failed";
            setError(message);
        }
        finally {
            setLoading(false);
        }
    }
    return (_jsx("div", { className: "flex min-h-screen items-center justify-center bg-[var(--color-muted)]", children: _jsxs("div", { className: "w-full max-w-sm rounded-[var(--radius-lg)] border border-[var(--color-border)] bg-[var(--color-card)] p-8 shadow-sm", children: [_jsx("h1", { className: "mb-6 text-center text-2xl font-bold tracking-tight", children: "Biotact Admin" }), _jsxs("form", { onSubmit: handleSubmit, className: "space-y-4", children: [_jsx(Input, { label: "Email", type: "email", required: true, value: email, onChange: (e) => setEmail(e.target.value), autoComplete: "email" }), _jsx(Input, { label: "Password", type: "password", required: true, value: password, onChange: (e) => setPassword(e.target.value), autoComplete: "current-password" }), error ? (_jsx("p", { role: "alert", className: "text-sm text-[var(--color-destructive)]", children: error })) : null, _jsx(Button, { type: "submit", loading: loading, className: "w-full", children: "Sign in" })] })] }) }));
}
